var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 11.4033L14.864 11.4148L14.8342 8.45864L13.6771 8.47033L13.6475 5.53736L12.0576 5.55342L12.0273 2.5587L11.1033 2.56804L11.0794 0.198504L9.60599 0.213395L9.61169 0.776835L7.68882 0.796269L7.70684 2.57921L5.78396 2.59864L5.80198 4.38158L3.88744 4.40093L3.90546 6.18388L1.98258 6.20331L2.00053 7.97853L0.077654 7.99796L0.185615 18.6802L2.10849 18.6607L2.12651 20.4437L4.04938 20.4242L4.0674 22.2072L5.98195 22.1878L5.99989 23.9631L7.92276 23.9436L7.94078 25.7266L9.86365 25.7071L9.88167 27.4901L21.4022 27.3736L21.3842 25.5907L23.2988 25.5713L23.2808 23.7884L25.2036 23.769L25.1857 21.9938L27.1086 21.9743L27.0905 20.1914L29.0051 20.172L28.9871 18.3891L30.9099 18.3697L30.802 7.68745L28.8791 7.70688L28.8612 5.93166L26.9466 5.95101L26.9286 4.16806L25.0057 4.1875L24.9877 2.40456L23.0648 2.42399L23.0468 0.641051L21.1323 0.660401L21.1505 2.4665L20.4929 2.47314L20.5346 6.60246L19.2694 6.61525L19.2996 9.60226L18.001 9.61538L18.0299 12.4789L17.4056 12.4852L17.4125 13.1644L17.4305 14.9474L16.0321 14.9615L15.9961 11.4033Z",
    fill: "#E9E122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41454 14.2101L9.4505 17.7683L13.2879 17.7295L13.252 14.1714L9.41454 14.2101Z",
    fill: "#6B223C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43825 16.5565L9.4505 17.7683L10.7574 17.7551L10.7451 16.5433L9.43825 16.5565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaka);
export default __webpack_public_path__ + "static/media/waka.2f0a6c70c2fa6b818af2349abc132fb5.svg";
export { ForwardRef as ReactComponent };